module.exports = __webpack_public_path__ + "media/images/badges/akt/milestone-3-Active-AKT-3959902325275e4e8e4e620344d4ca3f.png";